<template>
    <div class="ds-carousel-indicator">
        <ol class="ds-carousel-indicator__dots">
            <li
                class="dot"
                v-for="(_slide, idx) in dotHelper"
                :key="idx"
                @click="slider.moveToIdx(idx)"
                :class="{ 'is-selected': current === idx }"
            ></li>
        </ol>
    </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useTicketFamilySlider } from "../composables/use-ticket-family-slider";

const { slider, current, slideCount } = useTicketFamilySlider();

const dotHelper = computed(() => [...Array(slideCount.value ?? 3).keys()]);
</script>
